import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-details-one',
  templateUrl: './blog-details-one.component.html',
  styleUrls: ['./blog-details-one.component.scss']
})
export class BlogDetailsOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
